import * as React from 'react';
import {
   AddColumnAfterButton,
   AddColumnBeforeButton,
   AddRowAfterButton,
   AddRowBeforeButton,
   MergeOrSplitButton,
} from '../../components/buttons';
import { Flex, HStack } from '@chakra-ui/react';
import { shadow } from '@dozuki/web-js/primitives';
import { forwardRef, useImperativeHandle, useState } from 'react';

export interface TableCellBubbleMenuHandle {
   toggleVisibility: () => boolean;
   hide: () => boolean;
   show: () => boolean;
}

const TableCellBubbleMenuComponent: React.ForwardRefRenderFunction<TableCellBubbleMenuHandle> = (
   props,
   ref
) => {
   const [show, setShow] = useState(false);

   useImperativeHandle(ref, () => ({
      toggleVisibility: () => {
         setShow(!show);
         return true;
      },
      hide: () => {
         setShow(false);
         return true;
      },
      show: () => {
         setShow(true);
         return true;
      },
   }));

   if (!show) {
      return null;
   }

   return (
      <Flex>
         <HStack
            bgColor="gray.50"
            border="1px"
            borderColor="gray.300"
            borderRadius="md"
            padding="1"
            boxShadow={shadow[3]}
         >
            <AddColumnBeforeButton />
            <AddColumnAfterButton />
            <AddRowBeforeButton />
            <AddRowAfterButton />
            <MergeOrSplitButton />
         </HStack>
      </Flex>
   );
};

export const TableCellBubbleMenu = forwardRef(TableCellBubbleMenuComponent);
